import type { DefineMethods } from 'aspida'
import { mockMethods } from 'aspida-mock'

export type Methods = DefineMethods<{
  put: {
    reqBody: {
      interview_status?: number
      importance?: number
    }
    resBody: {
      message: string
    }
  }
  delete: {
    reqBody: Record<string, never>
  }
}>

export default mockMethods<Methods>({
  put: () => ({
    status: 200,
    resBody: {
      message: '更新しました',
    },
  }),
  delete: () => ({
    status: 200,
  }),
})
